module.exports = __webpack_public_path__ + "epdf-app/principal/container/container-delete-modal-15Q3ax6R.html";